export default {
    mobile: (mobile) => {
        if (!(/^1[3456789]\d{9}$/.test(mobile))) {
            return false;
        }
        return true;
    }
}